import { type ReactNode } from 'react'
import cx from 'classnames'
import styles from './SignatureSection.module.css'

export interface SignatureSectionProps {
  children?: ReactNode
  testId?: string
}

/**
 * The SignatureSection
 */
export function SignatureSection({ children, testId }: SignatureSectionProps) {
  return (
    <div className={cx(styles.root)} data-test={testId}>
      {children}
    </div>
  )
}

export interface SignatureDateLabelProps {
  children?: ReactNode
  testId?: string
}

/**
 * The SignatureDateLabel
 */
export function SignatureDateLabel({
  children,
  testId,
}: SignatureDateLabelProps) {
  return (
    <div className={cx(styles.signatureDateLabel)} data-test={testId}>
      {children}
    </div>
  )
}
